// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';


export const store = configureStore({
  reducer: rootReducer,
});

let previousTheme = store.getState().theme?.theme;
store.subscribe(() => {
  const currentTheme = store.getState().theme?.theme;
  if (currentTheme && currentTheme !== previousTheme) {
    previousTheme = currentTheme;
    try {
      localStorage.setItem("theme", currentTheme);
    } catch (_) {}
  }
});

